import React, { useEffect, useState } from "react";

import Plumbing from "../../../../assets/images/service/Plumbing/Plumbing.png";
import HVAC from "../../../../assets/images/service/HVAC/HVAC.png";
import Electrical from "../../../../assets/images/service/Electrical/Electrical.png";
import Roofing from "../../../../assets/images/service/Roofing/Roofing.png";
import Other from "../../../../assets/images/service/Other/Other@1x.png";
import Edit from "../../../../assets/images/service/pencil-green.png";
import deleteSvg from "../../../../assets/images/service/delete.svg";
import uniqueId from "lodash.uniqueid";
import { service } from "../Service";

interface IServiceMenu {
    serviceName: string;
    slotTypes: SlotType[];
    handleEditService: (serviceId: string, serviceType: string) => void;
    handleDeleteService: (serviceId: string, serviceType: string) => void;
    serviceId: string
    services: service[]
    serviceType: string
    otherServiceType: boolean
    activeServiceMap: Map<String,any>
}
interface SlotType {
    id: string
    slotType: string;
    slotFriendlyName: InputConfig;
    jobTypes: JobType[];
}
interface JobType {
    id: string
    jobType: string;
    jobTypeDesc: string;
    jobFriendlyName: InputConfig;
}
interface InputConfig {
    id: string;
    value: string;
}
const selectImgToShow = (serviceName: string): string => {
    let imgSelected;
    switch (serviceName) {
        case "Plumbing":
            imgSelected = Plumbing
            break;
        case "HVAC":
            imgSelected = HVAC
            break;
        case "Electrical":
            imgSelected = Electrical
            break;
        case "Roofing":
            imgSelected = Roofing
            break;
        default:
            imgSelected = Other
            break;
    }
    return imgSelected
}

const showServiceMenu = (serviceName: string, slotTypes: SlotType[], services: service[], otherServiceType:boolean ) => {
    if (serviceName !== "Other") {
        return slotTypes?.map((slotType, index) => {
            let jobTypeFriendlyName = ""
            slotType.jobTypes.forEach(jobType => {
                jobTypeFriendlyName += (jobType.jobFriendlyName.value && jobType.jobFriendlyName.value.length > 0 ? jobType.jobFriendlyName.value + ";" : jobType.jobTypeDesc + ";") ?? "" + "; "
            });
            return (
                <>
                    
                    <p key={index} className=" text-customBlue">{(slotType.slotFriendlyName.value && slotType.slotFriendlyName.value.length > 0) ? slotType.slotFriendlyName.value : slotType.slotType}</p>
                    <p key={uniqueId("title-")} className="custom-service-menu-JobType">{jobTypeFriendlyName}</p>
                </>
            )
        })
    } else {
            return (  <>{

                          findServiceFromServiceName(services,serviceName,otherServiceType)
                    }
             
             
           
              </>
        )
    }
}

const findServiceFromServiceName = (services:service[],serviceName: string, otherServiceType:boolean) => {
    let newRenderService = services.filter(service => {
        return service.serviceType === serviceName;
    })
        let currentSerice = services[0];
        
        if ((newRenderService != null) && (newRenderService.length>0))
        {
            currentSerice = newRenderService[0];
            let display="";
            display = currentSerice.serviceFriendlyName.value && currentSerice.serviceFriendlyName.value.length > 0 ? currentSerice.serviceFriendlyName.value : currentSerice.serviceType;           
            <p key={uniqueId("sm-1-")} className=" text-customBlue">{display}</p>      
        }
    return (

    <p key={uniqueId("sm-1-")} className=" text-customBlue">{currentSerice.serviceFriendlyName.value && currentSerice.serviceFriendlyName.value.length > 0 ? currentSerice.serviceFriendlyName.value : currentSerice.serviceType}</p>      
    )

}


/**
 * 
 * @param props  onClick injected from Service.tsx
 * @returns 
 */
const ServiceMenu = (props: IServiceMenu) => {
    const { serviceName, services,slotTypes,  handleEditService, handleDeleteService, serviceId, serviceType,activeServiceMap } = props;
    const currentService = services.filter(el => el.serviceType == serviceType);
    let serviceActive = true;
    if ((currentService!=null) && (currentService.length > 0)) {
        serviceActive = currentService[0].active;
    }
    if (!serviceActive){
            return(<></>)
        } 
        else
        {
            return (
                <div key={uniqueId("sm-")} className="flex  custom-service-menu h-auto mb-3 ">
                 
                    <div className="w-1/3 flex md:w-1/4">
                        <img src={selectImgToShow(serviceName)} alt="Pipe-Plumbering-Home Repair-Water-Blocked"
                            className={`mx-auto my-auto w-1/2 md:w-1/3 ${serviceName === "Other" ? "p-2" : ""} `} />
                    </div>
                    <div className="w-2/3">
                        <div className="flex justify-between ">
                            <p className="text-lg font-bold text-customBlue">{serviceName}</p>
                            <button
                                onClick={() => handleEditService(serviceId, serviceType)} className="flex"
                            >   
                                    <img src={Edit} alt="Edit Service button" className="mt-2" width="15px" />
        
                                <p className="mt-1 ml-1 mr-1 green-color">Edit</p>     
                            </button>
                            <button
                                onClick={() => handleDeleteService(serviceId, serviceType)} className="flex"
                            >   
                                    <img src={deleteSvg} alt="Delete Service button" className="mt-2" width="15px" />
                                <p className="mt-1 ml-1 mr-1 red-color">Delete</p>     
                            </button>
                        </div>
                        <div className="custom-service-menu-divider"></div>
                        {showServiceMenu(serviceName, slotTypes, services,props.otherServiceType)}
                    </div>
                </div>
        
            )
        }
    
}

export default ServiceMenu;
